import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { LearningRecordTabActionTypes } from "src/app/constants/StoreConstants";
import { GetLearningRecord, GetLearningRecordByLearnerId, GetLearningRecordError, SetSelectedCourseSuccess, SetTabState, SetTabStateSuccess, UpdateTabStateSuccess } from "./learning-record-tab.actions";
import { LearningTrackingService } from "src/app/_services/learning-tracking.service";
import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { sortInitialResultByDate } from "./learning-record-tab.utils";


@Injectable()

export class LearningRecordTabEffect {

    constructor(
        private action$: Actions,
        private router: Router,
        private learningTrackingService: LearningTrackingService
    ){}


    public updateTabStateEffect$ = createEffect(():Observable<Action> => {
        return this.action$.pipe(
            ofType(LearningRecordTabActionTypes.UpdateTabState),
            map(() => {
                return UpdateTabStateSuccess();
            })
            
        )
    });

    public selectedCourseEffect$ = createEffect(():Observable<Action> => {
        return this.action$.pipe(
            ofType(LearningRecordTabActionTypes.SetSelectedCourse),
            map(() => {
                return SetSelectedCourseSuccess();
            })
            
        )
    });

    public setTabStateSuccess$ = createEffect(():Observable<Action> => {
        return this.action$.pipe(
            ofType(LearningRecordTabActionTypes.SetTabState),
            map(() => {
                return SetTabStateSuccess();
            })
            
        )
    });

    public getLearningRecordEffect$ = createEffect((): Observable<Action> => {
        return this.action$.pipe(
            ofType(GetLearningRecord),
            switchMap((payload: {courseId: number}) => 
                this.learningTrackingService.getLearningRecordByCourseId$(payload.courseId).pipe(
                    map((result: LearnerLearningRecord[] ) => {
                        const learningRecords = sortInitialResultByDate(result);
                        return SetTabState({state: learningRecords, courseId: payload.courseId});
                    }),
                    catchError(() => {
                        return of(GetLearningRecordError());
                    })
                )
            )
        )
    });

    public getLearningRecordByLearnerIdEffect$ = createEffect((): Observable<Action> => {
        return this.action$.pipe(
            ofType(GetLearningRecordByLearnerId),
            switchMap((payload: {learnerId: number, courseId: number}) => 
                this.learningTrackingService.getLearningRecordByLearnerId$(payload.learnerId, payload.courseId).pipe(
                    map((result: LearnerLearningRecord[] ) => {
                        const learningRecords = sortInitialResultByDate(result);
                        return SetTabState({state: learningRecords, courseId: payload.courseId});
                    }),
                    catchError(() => {
                        return of(GetLearningRecordError());
                    })
                )
            )
        )
    });
}